module.exports = __webpack_public_path__ + "img/_Lemon.afc8f3d6.png";